import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/baseUi/avatar"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { useUser } from "@/modules/users/hooks/useUser"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { formatCurrency } from "@modules/currency/currency"
import { useLanguage } from "@modules/language/hooks/useLanguage"
import { LightProgramBundleInfo } from "@modules/programBundle/entities/programBundleEntity"
import { LightProgramInfoEntity } from "@modules/programs/entities/lightProgramInfoEntity"
import { ProgramType } from "@modules/programs/types/programTypes"
import { getFormattedReductedProgramPrice } from "@modules/promoCode/utils/promoCodeUtils"
import { ArrowRight } from "lucide-react"

type ProgramReductionItemProps = {
  program: LightProgramInfoEntity | LightProgramBundleInfo
  promoCodeValue?: number
  promoCodeType?: CouponType
  promoCodeDuration?: number
  className?: string
} & React.ComponentProps<"div">

export function ProgramReductionItem({
  program,
  promoCodeValue,
  promoCodeType,
  promoCodeDuration,
  className,
  ...props
}: ProgramReductionItemProps) {
  const language = useLanguage()
  const user = useUser()

  return (
    <div className={cn("mt-2 flex min-w-0 flex-1 flex-row gap-3", className)} {...props}>
      <Avatar className="size-10 shrink-0">
        <AvatarImage src={program.image?.url} alt="Program image" />
        <AvatarFallback>
          <Text fontStyle="LL">{program.name[0]}</Text>
        </AvatarFallback>
      </Avatar>
      <div className="flex min-w-0 flex-1 flex-col">
        <Text fontStyle="LL" className="truncate pr-4">
          {program.name}
        </Text>
        <Text fontStyle="BS" className="flex flex-row items-center gap-1">
          {`${formatCurrency(program.price?.value || 0, program.price?.currency || user.stripeAccountCurrency, language)} `}
          <ArrowRight strokeWidth={1} size={16} />
          {/* TODO : voir regele de gestion avec Nico */}
          {`${getFormattedReductedProgramPrice(language, program.price, promoCodeValue, promoCodeType, user.stripeAccountCurrency ?? undefined)}  ${!!promoCodeDuration && program.type === ProgramType.VIRTUAL ? word("promoCode.duringXMonths", { count: promoCodeDuration }) : ""}`}
        </Text>
      </div>
    </div>
  )
}
